"use client"

import { useState } from "react"
import { Modal } from "react-bootstrap"
import { resetPassword } from "../../services/apiService"
import "../Header/login.css"

const ForgotPasswordModal = ({ show, onHide, showLoginModal }) => {
  const [email, setEmail] = useState("")
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [message, setMessage] = useState(null)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setIsSubmitting(true)
    setMessage(null)

    try {
      const params = new URLSearchParams()
      params.append("mode", "resetPasswordUtilisateur")
      params.append("STR_UTIMAIL", email)

      const response = await resetPassword(params)
      const result = response.data

      if (result.code_statut === "1") {
      
        setMessage({
          type: "success",
          text: "Un email contenant votre identifiant et un nouveau mot de passe a été envoyé à votre adresse email.",
        })
        setEmail("")

        
        setTimeout(() => {
          onHide()
          showLoginModal()
        }, 5000) // Redirection vers la page de connexion apres 5 secondes
      } else {
        setMessage({
          type: "error",
          text: result.desc_statut || "Une erreur est survenue. Veuillez réessayer.",
        })
      }
    } catch (error) {
      setMessage({
        type: "error",
        text: "Une erreur est survenue. Veuillez réessayer.",
      })
      console.error("Erreur de réinitialisation:", error)
    } finally {
      setIsSubmitting(false)
    }
  }

  const handleBackToLogin = (e) => {
    e.preventDefault()
    onHide()
    showLoginModal()
  }

  return (
    <Modal size="lg" show={show} onHide={onHide} centered>
      <Modal.Body>
        <div className="row justify-content-center flex-wrap">
          <div className="login-container">
            <div className="login-left">
              <h1 className="">
                <span className="highlight">Mot de passe oublié</span>
              </h1>

              {message && message.type === "success" ? (
                <div className="success-container">
                  <div className="success-message">
                    <div className="success-icon">
                      <i className="fas fa-check-circle"></i>
                    </div>
                    <p style={{ color: "#28a745" }}>{message.text}</p>
                    <p className="redirect-text">Vous allez être redirigé vers la page de connexion...</p>
                    <button className="btn btn-outline-primary mt-3" onClick={handleBackToLogin}>
                      Retour à la connexion
                    </button>
                  </div>
                </div>
              ) : (
                <>
                  <p className="text-center">
                    Entrez votre adresse email pour recevoir votre identifiant et un nouveau mot de passe
                  </p>

                  {message && message.type === "error" && (
                    <div className="alert alert-danger" role="alert">
                      {message.text}
                    </div>
                  )}

                  <form onSubmit={handleSubmit}>
                    <div className="input-group height-updated">
                      <input
                        type="email"
                        id="email"
                        placeholder="Adresse email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="input-field"
                        required
                      />
                    </div>

                    <button type="submit" className="btn btn-submit" disabled={isSubmitting}>
                      {isSubmitting ? "Envoi en cours..." : "Réinitialiser le mot de passe"}
                    </button>
                  </form>

                  <p className="signup mt-4">
                    <a href="#" onClick={handleBackToLogin}>
                      Retour à la connexion
                    </a>
                  </p>
                </>
              )}
            </div>

            <div className="login-right d-none d-md-block">
              <div className="company-info">
                <img src="/assets/images/logo-blanc.png" alt="SN Proveci Logo" className="company-logo" />
                <h2 className="highlight">GROSSISTE VÉTÉRINAIRE</h2>
                <p>
                  En tant que client bénéficiez d'un accompagnement personnalisé, commandez en ligne, accédez à des
                  offres préférentielles
                </p>
              </div>
              <div className="animal-icons">
                <img src="assets/images/icone.png" alt="Icon" />
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default ForgotPasswordModal

